import { BaseEntity } from "../../core";
import { LetterMultimedia } from "./letterMultimedia";

export class Letter extends BaseEntity {
    public internalNumber: number;
    public sinester: number;
    public domain: string;
    public driver: string;
    public dateIncome: Date;
    public dateIncomeString: string;
    public dateSinester: Date;
    public dateSinesterString: string;
    public state: string;
    public stateId: number;
    public label: number;
    public multimedia: LetterMultimedia;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/letter.ts